import React from 'react';
import uniq from 'lodash/uniq';

export const FAQS = [
  {
    question: 'How was AFEX established?',
    answer: (
      <p>{`
        AFEX Commodities Exchange Limited (AFEX)Nigeria was established in Nigeria in 2014 
        through a Public Private Partnership with the Federal Ministry of Agriculture and 
        Rural Development (FMARD) to establish a Warehouse Receipt System (WRS) and Commodities 
        Exchange for Nigeria. AFEX secured its license as a Commodities Exchange in compliance 
        with the Investments & Securities Act, 2007 and the Securities and Exchange 
        Commission’s Rules & Regulations in March 2015 and is the first private-sector 
        led and funded Commodities Exchange in Nigeria and across West and Central Africa.
    `}</p>
    ),
    category: 'AFEX',
  },
  {
    question: 'What does AFEX do?',
    answer: (
      <p>{`
        We enable the transition from production to transaction for agriculture commodities. 
        AFEX Nigeria provide solutions to farmer’s challenges in aggregation, storage and 
        financial inclusion. AFEX Nigeria generates agri-finance data, intelligence, and deal 
        flow to increase private sector investment in commodities.
    `}</p>
    ),
    category: 'AFEX',
  },
  {
    question: 'What are the products offered by AFEX?',
    answer: (
      <ol>
        <li>Forward Contracts</li>
        <li>Exchange Traded Commodities</li>
        <li>Input Program</li>
        <li>Asset Backed Commercial Paper</li>
        <li>AFEX Commodity Index</li>
        <li>AFEX Collateral Management</li>
        <li>AFEX Repo/Buy Back</li>
      </ol>
    ),
    category: 'AFEX',
  },
  {
    question: 'AFEX technical capabilities',
    answer: (
      <p>
        {`
        We pride ourselves as the leader in commercial storage and collateral management 
        services in the country with a strong focus on preserving the integrity of the 
        underlying assets and also managing the risk of our clients.
        `}
      </p>
    ),
    category: 'AFEX',
  },
  {
    question: 'Why become a member?',
    answer: (
      <p>
        {`
        We are an organized and efficient platform within which financial market participants 
        can actively participate in the commodities markets. Our Members are from diverse 
        firms and interest groups, ranging from the farmers, dealers, market regulators, market 
        makers, investors, brokers and other interested participants. As a Member of AFEX, 
        you gain access to one of Africa’s leading and largest commodities exchanges
        `}
      </p>
    ),
    category: 'AFEX',
  },
  {
    question: 'Who can apply to be a member?',
    answer: (
      <p>
        {`
        Any individual/institution can become a member. You can become a member whether you’re a farmer, 
        a private investor looking to diversify your portfolio, a business or intermediary seeking 
        capital, or a public agency or philanthropic foundation looking to make your funds go further. 
        As a member you will join a global community of institutions and businesses dedicated to 
        increasing the livelihood of smallholder farmers and driving capital to where it is needed most.
        `}
      </p>
    ),
    category: 'AFEX',
  },
  {
    question: 'What benefit does AFEX offer to its members?',
    answer: (
      <>
        <p>
          {`AFEX offers its members a combination of the following benefits:`}
        </p>
        <ul>
          <li>
            {`
            Data & Intelligence: Original content that builds the evidence base for Agri-finance 
            and supports practitioners in their efforts to execute transactions, including 
            access to data on past finance transactions, trend reports, region and sector briefs.
            `}
          </li>
          <li>
            {`
            Deal Flow: An online deal and investor matchmaking platform for investors and those seeking 
            capital to connect on finance deals.
            `}
          </li>
        </ul>
      </>
    ),
    category: 'AFEX',
  },
  {
    question: 'How much does membership cost?',
    answer: (
      <p>
        {`Membership fees are due annually and are dependent on type. Read more on our membership categories `}
        <a href="https://afexnigeria.com">here.</a>
      </p>
    ),
    category: 'AFEX',
  },
  {
    question: 'What is a Commodities Exchange?',
    answer: (
      <>
        <p>
          {`
            A commodities exchange is a legal entity that determines and enforces 
            rules and procedures for the trading of standardized commodity contracts.
          `}
        </p>
        <p>
          {`
            AFEX Commodities Exchange provides a national trading platform and 
            develops a supply chain network for select commodities. Our approach is to 
            create a market that includes the small local farmers which means not 
            providing an exchange for the financial market alone.
            `}
        </p>
        <p>
          {`
            AFEX provides support for this process and encourage practitioners by 
            designing vehicles that make investment opportunities that are otherwise too 
            risky or complex to pursue, easier and safer for farmers and investors.
            `}
        </p>
      </>
    ),
    category: 'Commodities Exchange',
  },
  {
    question: 'What is the legal framework to regulate the commodity market?',
    answer: (
      <p>
        {`
            The Securities and Exchange Commission (SEC), Nigeria is the apex regulatory 
            institution of the Nigerian commodities market, and is supervised by the 
            Federal Ministry of Finance.
        `}
      </p>
    ),
    category: 'Commodities Exchange',
  },
  {
    question: 'Why should I invest in agricultural commodities?',
    answer: (
      <p>
        {`
            Agricultural commodities may be appealing as an investment for many reasons. 
            These assets can serve as an effective hedge against inflation, since food prices 
            are often among the first to rise when prices begin to climb. Agricultural 
            commodities can also perform well when global populations are growing, or when a 
            growing middle class leads to increased demand.
        `}
      </p>
    ),
    category: 'Commodities Exchange',
  },
  {
    question: 'What is a commodity warehouse?',
    answer: (
      <p>
        {`
            A warehouse is a building that is constructed for storage of commodities
            such as manufactured goods, agricultural produce, etc.
        `}
      </p>
    ),
    category: 'Commodities Exchange',
  },
  {
    question:
      'What are the investment opportunities available in the commodities market?',
    answer: (
      <p>
        {`
            Commodities markets across the world trade in agricultural products and
            other raw materials (like wheat, barley, sugar, maize, cotton, cocoa,
            coffee, milk products, oil, metals,etc.) and contracts based on them.
            These contracts can include spot prices, forwards,futures and options on
            futures
        `}
      </p>
    ),
    category: 'Commodities Exchange',
  },
  {
    question: 'What is a warehouse receipt?',
    answer: (
      <p>
        {`
            A warehouse receipt is a document of title showing grade, weight, mode 
            of packaging, name and address of the warehouse manager and, in some 
            cases, the shelve life of the commodity
        `}
      </p>
    ),
    category: 'Commodities Exchange',
  },
  {
    question: 'Can warehouse receipts be traded?',
    answer: <p>{`Yes, if it is negotiable`}</p>,
    category: 'Commodities Exchange',
  },
  {
    question: 'How will farmers know the current price of their produce?',
    answer: (
      <p>
        {`
        Closing Prices of agricultural produce on the exchange are displayed in our warehouses 
        and will be relayed daily on radio and television as well as published in the print media. 
        Information on current prices of agricultural produce can also be obtained from AFEX Website.
        `}
      </p>
    ),
    category: 'Agriculture',
  },
  {
    question: 'Who can trade on a commodity exchange?',
    answer: (
      <p>
        {`
        Like on a Stock Exchange, individuals are not allowed to trade directly on a 
        Commodity Exchange except through accredited commodity brokers who are registered 
        members of the exchange.
        `}
      </p>
    ),
    category: 'Agriculture',
  },
  {
    question: 'Who can access the exchange?',
    answer: (
      <p>
        {`
        Anyone that is engaged in the commodity business can make use of the exchange. 
        This includes farmers, commodity merchants and commodity processors such as 
        food and beverage companies.
        `}
      </p>
    ),
    category: 'Agriculture',
  },
  {
    question:
      'Why should major consumers of agricultural produce make use of a commodity exchange in sourcing their raw materials?',
    answer: (
      <>
        <p>
          {`
        Apart from promoting realistic pricing and price discovery, a Commodities exchange is 
        capable of making possible the following for the major consumers:
        `}
        </p>
        <ol>
          <li>{`Low cost of transaction as there will be a reduction in search cost`}</li>
          <li>{`Guaranteed quality`}</li>
          <li>
            {`
            Regular supply of the required raw materials as AFEX will have a network of members 
            that are merchants in various crops
            `}
          </li>
          <li>
            {`
            Reduction or total elimination of contract failures as trading members operate 
            strictly according to the rules
            `}
          </li>
        </ol>
      </>
    ),
    category: 'Agriculture',
  },
  {
    question:
      'Is there any minimum quantity that one can trade on the exchange?',
    answer: <p>{`The minimum quantity that can be traded is 1 Metric Ton`}</p>,
    category: 'Agriculture',
  },
  {
    question: 'What determines the contract size?',
    answer: <p>{`They are set and determined by the exchange`}</p>,
    category: 'Agriculture',
  },
  {
    question: 'Is trade default possible on an exchange?',
    answer: <p>{`Yes, but very rare`}</p>,
    category: 'Agriculture',
  },
  {
    question:
      'Where can I find the descriptions of commodity prices and indices, including data sources and commodity grades and weights?',
    answer: (
      <p>
        {`Commodity grades and weights can be found `}
        <a href="https://afexnigeria.com">here</a>
      </p>
    ),
    category: 'Agriculture',
  },
  {
    question:
      'If I buy now, what happens if I am not interested in the physical commodity?',
    answer: (
      <p>
        {`You monitor the prices, through our index and price reports. 
        When you are ready to trade, we facilitate the trade through the exchange.`}
      </p>
    ),
    category: 'Agriculture',
  },
  {
    question: 'How long would trade take?',
    answer: <p>{`Instantaneously`}</p>,
    category: 'Agriculture',
  },
  {
    question:
      'How soon can I expect returns following the execution of a trade?',
    answer: (
      <p>{`Settlement is due two days after trade execution whilst clearing is one day after execution.`}</p>
    ),
    category: 'Agriculture',
  },
  {
    question: 'What are the trading hours?',
    answer: <p>{`10am -2pm`}</p>,
    category: 'Agriculture',
  },
];

export const FAQ_CATEGORIES = uniq(FAQS.map(x => x.category));
